import React from 'react';
import styled from 'styled-components';
import { FlexColumnCenter, Avatar as BaseAvatar, SmallBody, FlexMiddle, Small } from '@ubeya/shared-web/components';
import { ReactComponent as Star } from '@ubeya/shared-web/assets/star.svg';
import { media, responsiveRow } from '@ubeya/shared-web/style';

const Wrapper = styled.div`
  display: flex;
  ${responsiveRow.tablet}
  padding: 10px 10%;
  margin: 0 auto;
  justify-content: space-between;
  width: 100%;
`;

const Employee = styled(FlexColumnCenter)`
  margin-bottom: 20px;
  ${media.tablet`
    margin-bottom: 0;
  `}
`;

const Avatar = styled(BaseAvatar)`
  margin-bottom: 12px;
`;

const Name = styled(SmallBody)`
  margin-top: 7px;
`;

const RatingRow = styled(FlexMiddle)`
  margin-top: 7px;
  color: ${({ theme }) => theme.colors.disabled};
  > svg {
    width: 13px;
    height: 13px;
    margin-right: 5px;
    > path {
      fill: ${({ theme }) => theme.colors.greenPositive};
    }
  }
`;

const Shifts = styled(SmallBody)`
  margin-top: 7px;
  color: ${({ theme }) => theme.colors.disabled};
`;

const TopEmployees = ({ users, className }) => (
  <Wrapper className={className}>
    {users.map((user, index) => (
      <Employee key={index}>
        <Avatar {...user} size="big" />
        <Name>{[user.firstName, user.lastName].join(' ')}</Name>
        <RatingRow>
          <Star />
          <Small>{user.rating}</Small>
        </RatingRow>
        <Shifts>{user.shifts} shifts</Shifts>
      </Employee>
    ))}
  </Wrapper>
);

export default TopEmployees;
